// Champ de mot de passe avec l'œil pour le relire.
//
// POURQUOI CE COMPOSANT EXISTE, ET POURQUOI IL N'Y EN A QU'UN
//
// Les mots de passe de ce logiciel sont donnés de vive voix ou par écrit par
// un administrateur, puis retapés — et la politique en exige douze caractères.
// Une faute de frappe invisible se solde par un « mot de passe incorrect » qui
// ne dit pas où l'erreur est, et au cinquième essai le compte se verrouille
// pour quinze minutes. L'œil supprime la moitié de ces appels.
//
// Il y a plusieurs écrans où l'on tape un mot de passe (connexion, mon compte,
// réinitialisation). Recopié dans chacun, le comportement finirait par
// diverger — et c'est la copie oubliée qui garderait le mot de passe affiché.
//
// CE QU'IL NE FAIT PAS : il ne mémorise rien. L'état « visible » vit le temps
// du champ et repart à `false` à chaque montage. Un champ qui reste en clair
// parce qu'on l'a ouvert la fois d'avant expose le mot de passe à qui passe
// derrière l'écran.
import { useId, useState } from "react";

import { IconeOeil, IconeOeilBarre } from "./Icones";

export default function ChampMotDePasse({
  label,
  value,
  onChange,
  autoComplete = "current-password",
  required = false,
  placeholder,
  className = "champ",
  aide,
}) {
  const [visible, setVisible] = useState(false);
  const id = useId();

  return (
    <div className={className}>
      <label className="champ-label" htmlFor={id}>
        {label}
      </label>
      <div className="champ-mdp">
        <input
          id={id}
          type={visible ? "text" : "password"}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          autoComplete={autoComplete}
          required={required}
          placeholder={placeholder}
        />
        <button
          type="button"
          className="champ-mdp-oeil"
          onClick={() => setVisible((v) => !v)}
          // Le libellé décrit CE QUE FAIT le bouton, pas l'état courant :
          // c'est ce qu'attend un lecteur d'écran, et ce que comprend un
          // utilisateur qui survole.
          aria-label={visible ? "Masquer le mot de passe" : "Afficher le mot de passe"}
          title={visible ? "Masquer le mot de passe" : "Afficher le mot de passe"}
          // Hors du parcours au clavier : on tabule d'un champ au suivant,
          // pas vers un bouton d'affichage.
          tabIndex={-1}
        >
          {visible ? <IconeOeilBarre /> : <IconeOeil />}
        </button>
      </div>
      {aide && <span className="sous-info">{aide}</span>}
    </div>
  );
}
